import { createTheme } from '@mui/material';
import { defaultStyleComponents } from './defaultStyleComponents';
import { defaultDarkColor, defaultLightColor } from './defaultColors';

export const blueLightTheme = createTheme({
  components: { ...defaultStyleComponents },
  spacing: (abs: number) => `${0.35 * abs}rem`,
  palette: {
    mode: 'light',
    primary: {
      main: '#0071EB',
      900: '#001429',
      800: '#002952',
      700: '#003D7A',
      600: '#0052A3',
      500: '#0071EB',
      400: '#3395F0',
      300: '#66B8F5',
      200: '#99DBFA',
      100: '#CCEDFF',
      50: '#E6F6FF',
    },
    ...defaultLightColor,
    customColor: {
      main: '#0071EB',
      100: '#0052A3',
      gradient:
        'linear-gradient(90deg, rgba(0, 113, 235, 0.1) 0%, rgba(0, 113, 235, 0.3) 100%)',
    },
    customColor2: {
      main: '#141414',
    },
    customColorTable: {
      main: '#0071EB',
      oddRow: '#E6F6FF',
    },
  },
});

export const blueDarkTheme = createTheme({
  components: { ...defaultStyleComponents },
  spacing: (abs: number) => `${0.35 * abs}rem`,
  palette: {
    mode: 'dark',
    primary: {
      main: '#0071EB',
      900: '#141414',
      800: '#001429',
      700: '#002952',
      600: '#003D7A',
      500: '#0052A3',
      400: '#0071EB',
      300: '#3395F0',
      200: '#66B8F5',
      100: '#1a1a1a',
      50: '#262626',
    },
    ...defaultDarkColor,
    customColor: {
      main: '#0071EB',
      100: '#3395F0',
      gradient:
        'linear-gradient(90deg, rgba(20, 20, 20, 0.8) 0%, rgba(0, 113, 235, 0.3) 100%)',
    },
    customColor2: {
      main: '#141414',
    },
    customColorTable: {
      main: '#0071EB',
      oddRow: '#1a1a1a',
    },
  },
});
